
import { defineComponent } from "vue";
import MainLogin from "@/components/login/MainLogin.vue";

export default defineComponent({
  components: {
    MainLogin,
  },
});
